import { Combobox } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { FC, useEffect, useState } from "react";
import { collectionsListName } from "src/api/config";
import { getItemsRequest } from "src/modules/spItems/api";

interface IProps {
  testName: string;
  selectedCollection: any;
  setTestName: (value: string) => void;
  setSelectedCollection: (collection: {}) => void;
}

export const TestRegistryFilters: FC<IProps> = ({ testName, selectedCollection, setTestName, setSelectedCollection }) => {
  const [collectionsList, setCollectionsList] = useState<any>([]);
  const [collectionName, setCollectionName] = useState("");

  const handleClearCollection = () => {
    setSelectedCollection({});
    setCollectionName("");
  };

  useEffect(() => {
    getItemsRequest({ listName: collectionsListName }).then(results => setCollectionsList(results?.items));
  }, []);

  return (
    <div className="flex justify-between gap-5 mb-5">
      <div className="w-full">
        <Combobox as="div" value={selectedCollection} onChange={collection => setSelectedCollection(collection)}>
          <Combobox.Label className="text-base font-medium text-black mb-[10px]">Коллекция</Combobox.Label>
          <div className="relative mt-2">
            <Combobox.Input
              placeholder="Выберите коллекцию"
              className="w-full rounded-md border-0 bg-white py-2 px-5 pr-20 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 placeholder:text-gray-400"
              onChange={e => setCollectionName(e.target.value)}
              displayValue={(collection: { Title: string }) => collection.Title || collectionName}
            />

            <Combobox.Button className="absolute inset-y-0 right-10 flex items-center rounded-r-md px-2 focus:outline-none" onClick={handleClearCollection}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </Combobox.Button>

            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
              <ChevronDownIcon className="w-5 h-5" aria-hidden="true" />
            </Combobox.Button>
            {collectionsListName.length > 0 && (
              <Combobox.Options className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {collectionsList
                  .filter((collection: any) => collection.Title.toLowerCase().includes(collectionName.toLowerCase()))
                  .map((collection: any) => (
                    <Combobox.Option key={collection.ID} value={collection} className="group hover:bg-[#F3F4F6] hover:bg-opacity-50 relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900">
                      <div className="flex items-center">
                        <span className="ml-3 truncate font-normal group-focus:font-semibold">{collection.Title}</span>
                      </div>

                      {collection.Title === selectedCollection?.Title ? (
                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-focus:text-white">
                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                        </span>
                      ) : null}
                    </Combobox.Option>
                  ))}
              </Combobox.Options>
            )}
          </div>
        </Combobox>
      </div>

      <div className="w-full">
        <label htmlFor="testName" className="block text-sm font-medium leading-6 text-gray-900">
          Название теста
        </label>
        <div className="mt-2 relative">
          <input
            value={testName}
            onChange={e => setTestName(e.target.value)}
            id="testName"
            name="testName"
            type="text"
            placeholder="Введите название теста"
            className="block w-full h-10 rounded-md border-0 py-1.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <button className="absolute inset-y-0 right-2 flex items-center rounded-r-md px-2 focus:outline-none" onClick={() => setTestName("")}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};
